module.exports = __webpack_public_path__ + "img/yiyao_xuezhi.fdb29bea.png";